import React from "react";

import SliderOne from "./slider-one/SliderOne";
import SliderTwo from "./slider-two/SliderTwo";

const designComponents = {
  "slider-one": SliderOne,
  "slider-two": SliderTwo,
};

const Design = ({ data, isPreview = false, canEdit = false, isView }) => {
  const DesignComponent = designComponents[data?.design];

  return (
    <DesignComponent
      data={data}
      isPreview={isPreview}
      canEdit={canEdit}
      isView={isView}
    />
  );
};

export default Design;
